module.exports = __webpack_public_path__ + "images/external_images/img/business-screen-3.png";